import dayjs from "dayjs";

export function logData(globalStatus: any, options: any = {}) {
  const { interactionType } = options;
  const date = dayjs().format("YYYY-MM-DD");
  const time = dayjs().format("HH:mm:ss");
  globalStatus.current.logData.push([date, time, interactionType]);
}
